import React, { useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import { getDoktorlarPanel } from '../services/api';

const AYLAR = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
               'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
const GUNLER = ['Pt','Sa','Ça','Pe','Cu','Ct','Pa'];

// ── Takvim bileşeni — memo ile gereksiz re-render önlenir ────────────────────
const Takvim = React.memo(function Takvim({ seciliTarih, ay, onAyDegis, onSecim }) {
  const bugun = new Date(); bugun.setHours(0,0,0,0);
  const sinir = bugun; // panelde bugün her zaman seçilebilir

  const yil  = ay.getFullYear();
  const ayNo = ay.getMonth();

  let ilk = new Date(yil, ayNo, 1).getDay() - 1;
  if (ilk < 0) ilk = 6;
  const son = new Date(yil, ayNo + 1, 0).getDate();

  const hücreler = [];
  for (let i = 0; i < ilk; i++) hücreler.push(null);
  for (let i = 1; i <= son; i++) hücreler.push(i);

  const sec = (gun) => {
    if (!gun) return;
    const d = new Date(yil, ayNo, gun);
    if (d < sinir) return;
    const iso = `${yil}-${String(ayNo+1).padStart(2,'0')}-${String(gun).padStart(2,'0')}`;
    onSecim(iso);
  };

  const s = { border: '1px solid #b0b8c8', background: '#fff', borderRadius: 8, overflow: 'hidden', maxWidth: 310, fontFamily: 'Tahoma, sans-serif', fontSize: 13 };

  return (
    <div style={s}>
      <div style={{ background: '#2a4a6b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 10px' }}>
        <button onClick={() => onAyDegis(new Date(yil, ayNo-1, 1))}
          style={{ background:'none', border:'none', color:'#fff', fontSize:16, cursor:'pointer', padding:'0 6px', lineHeight:1 }}>◄</button>
        <span style={{ fontWeight:700, fontSize:14 }}>{AYLAR[ayNo]} {yil}</span>
        <button onClick={() => onAyDegis(new Date(yil, ayNo+1, 1))}
          style={{ background:'none', border:'none', color:'#fff', fontSize:16, cursor:'pointer', padding:'0 6px', lineHeight:1 }}>►</button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', background:'#dde4ee' }}>
        {GUNLER.map(g => (
          <div key={g} style={{ textAlign:'center', padding:'5px 0', fontWeight:700, color:'#2a4a6b', fontSize:12 }}>{g}</div>
        ))}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', padding:'4px 6px 8px', gap:2 }}>
        {hücreler.map((gun, idx) => {
          if (!gun) return <div key={`e${idx}`} />;
          const d = new Date(yil, ayNo, gun);
          const iso = `${yil}-${String(ayNo+1).padStart(2,'0')}-${String(gun).padStart(2,'0')}`;
          const gecmis = d < sinir;
          const secili = iso === seciliTarih;
          const cumartesi = d.getDay() === 6;
          const pazar = d.getDay() === 0;
          return (
            <div key={gun} onClick={() => sec(gun)}
              style={{
                textAlign:'center', padding:'6px 2px', borderRadius:5,
                cursor: gecmis ? 'default' : 'pointer',
                fontWeight: secili ? 700 : 400,
                background: secili ? '#2a4a6b' : 'transparent',
                color: secili ? '#fff' : gecmis ? '#bbb' : pazar ? '#c0392b' : cumartesi ? '#2980b9' : '#222',
                border: secili ? 'none' : '1px solid transparent',
                userSelect:'none',
              }}>
              {gun}
            </div>
          );
        })}
      </div>
    </div>
  );
});

// ── Panel versiyonu — SMS doğrulaması yok ────────────────────────────────────
export default function RandevuVer() {
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const siteId    = kullanici.siteId || kullanici.SiteId || 0;
  const userDokKod = kullanici.dokKod || 0;
  const doktorAdi  = kullanici.adSoyad || 'Doktor';

  const [doktorlar, setDoktorlar] = useState([]);
  const [seciliDokKod, setSeciliDokKod] = useState(0);

  useEffect(() => {
    if (userDokKod === 0 && siteId) {
      getDoktorlarPanel(siteId)
        .then(r => { setDoktorlar(r.data); if (r.data.length > 0) setSeciliDokKod(r.data[0].kod); })
        .catch(() => {});
    }
  }, [userDokKod, siteId]);

  const isoTarih = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const baslangic = isoTarih(new Date()); // panel: bugün

  // Takvim ay görünümü — parent'ta tutulur, reset olmaz
  const [ay, setAy] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });

  const [tarih, setTarih]       = useState(baslangic);
  const [saat, setSaat]         = useState('');
  const [adSoy, setAdSoy]       = useState('');
  const [cepTel, setCepTel]     = useState('');
  const [tcKimlik, setTcKimlik] = useState('');

  const [bosSaatler, setBosSaatler] = useState([]);
  const [saatYukl, setSaatYukl]     = useState(false);
  const [saatMesaj, setSaatMesaj]   = useState('');

  const [yukleniyor, setYukl] = useState(false);
  const [hata, setHata]       = useState('');

  // Stable callback'ler — her render'da yeni fonksiyon oluşmasın
  const handleTarihSec = useCallback((iso) => setTarih(iso), []);
  const handleAyDegis  = useCallback((yeniAy) => setAy(yeniAy), []);

  useEffect(() => {
    if (!tarih || !siteId) return;
    setSaat('');
    setBosSaatler([]);
    setSaatMesaj('');
    setSaatYukl(true);
    const aktifDokKod = userDokKod > 0 ? userDokKod : seciliDokKod;
    const saatUrl = `/Randevu/bos-saatler?siteId=${siteId}&tarih=${tarih}${aktifDokKod > 0 ? `&dokKodOverride=${aktifDokKod}` : ''}`;
    API.get(saatUrl)
      .then(r => {
        if (r.data.mesaj) setSaatMesaj(r.data.mesaj);
        else setBosSaatler(r.data.saatler || []);
      })
      .catch(() => setSaatMesaj('Saatler yüklenemedi'))
      .finally(() => setSaatYukl(false));
  }, [tarih, siteId, seciliDokKod, userDokKod]);

  const tarihGoster = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-').map(Number);
    const dt = new Date(y, m-1, d);
    const gunler = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    return `${d} ${AYLAR[m-1]} ${y} ${gunler[dt.getDay()]}`;
  };

  const randevuKaydet = async (e) => {
    e.preventDefault();
    if (!tarih) { setHata('Lütfen tarih seçiniz'); return; }
    if (!saat)  { setHata('Lütfen saat seçiniz');  return; }
    const tel = cepTel.replace(/\D/g, '');
    if (tel.length < 10 || !tel.startsWith('5')) { setHata('Geçersiz cep telefonu (5 ile başlayan 10 hane)'); return; }
    setHata(''); setYukl(true);
    try {
      const dokKod = userDokKod > 0 ? userDokKod : seciliDokKod;
      await API.post('/Randevu/kaydet-panel', { siteId, dokKod, tarih, saat, adSoy, cepTel, tcKimlik });
      sifirla();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Randevu kaydedilemedi');
    } finally { setYukl(false); }
  };

  const sifirla = () => {
    setTarih(baslangic); setSaat(''); setAdSoy(''); setCepTel(''); setTcKimlik('');
    setBosSaatler([]); setSaatMesaj('');
    setHata('');
  };

  return (
    <div>
      <h1 className="sayfa-baslik">Randevu Ver</h1>

      {hata && <div style={{ padding:12, background:'#f8d7da', color:'#721c24', borderRadius:6, marginBottom:16 }}>{hata}</div>}

      {userDokKod === 0 ? (
        <div style={{ marginBottom:12, maxWidth:310 }}>
          <label style={{ fontFamily:'Tahoma', fontSize:12, fontWeight:600, color:'#2a4a6b', display:'block', marginBottom:4 }}>Doktor Seçiniz</label>
          <select
            value={seciliDokKod}
            onChange={e => { setSeciliDokKod(Number(e.target.value)); setSaat(''); setBosSaatler([]); }}
            className="input"
            style={{ width:'100%' }}
          >
            {doktorlar.map(d => (
              <option key={d.kod} value={d.kod}>{d.ad}{d.brans ? ` — ${d.brans}` : ''}</option>
            ))}
          </select>
        </div>
      ) : (
        <div style={{
          background:'#2a4a6b', color:'#fff', fontFamily:'Tahoma, sans-serif',
          fontWeight:700, fontSize:14, padding:'8px 14px', borderRadius:'8px 8px 0 0',
          maxWidth:310, marginBottom:0,
        }}>
          {doktorAdi}
        </div>
      )}

      <Takvim
        seciliTarih={tarih}
        ay={ay}
        onAyDegis={handleAyDegis}
        onSecim={handleTarihSec}
      />

      <div style={{ maxWidth:500, marginTop:12 }}>
        {tarih && (
          <div style={{ background:'#2a4a6b', color:'#fff', fontFamily:'Tahoma, sans-serif',
            fontWeight:600, fontSize:13, padding:'6px 12px', borderRadius:'6px 6px 0 0' }}>
            {tarihGoster(tarih)}
          </div>
        )}
        <div style={{ border:'1px solid #b0b8c8', borderTop: tarih ? 'none' : '1px solid #b0b8c8',
          borderRadius: tarih ? '0 0 8px 8px' : 8, background:'#fff', padding:12, minHeight:60 }}>
          {!tarih && <div style={{ color:'#888', fontSize:13 }}>Lütfen yukarıdan bir tarih seçiniz.</div>}
          {tarih && saatYukl && <div style={{ color:'#888', fontSize:13 }}>Saatler yükleniyor...</div>}
          {tarih && !saatYukl && saatMesaj && <div style={{ color:'#c00', fontSize:13 }}>{saatMesaj}</div>}
          {tarih && !saatYukl && !saatMesaj && bosSaatler.length === 0 && (
            <div style={{ color:'#c00', fontSize:13 }}>Bu tarihte uygun saat bulunmamaktadır.</div>
          )}
          {tarih && !saatYukl && bosSaatler.length > 0 && (
            <>
              <div style={{ fontFamily:'Tahoma', fontSize:12, fontWeight:600, marginBottom:6, color:'#2a4a6b' }}>Saat Seçiniz</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:'6px 14px' }}>
                {bosSaatler.map(s => (
                  <label key={s} style={{ display:'flex', alignItems:'center', gap:4, cursor:'pointer',
                    fontFamily:'Tahoma', fontSize:13, color: saat===s ? '#2a4a6b' : '#333', fontWeight: saat===s ? 700 : 400 }}>
                    <input type="radio" name="saat" value={s} checked={saat===s}
                      onChange={() => setSaat(s)} style={{ cursor:'pointer' }} />
                    {s}
                  </label>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <form onSubmit={randevuKaydet}>
        <div style={{ maxWidth:400, marginTop:16, display:'flex', flexDirection:'column', gap:10 }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <label style={{ minWidth:110, fontFamily:'Tahoma', fontSize:13, fontWeight:600 }}>Ad Soyad</label>
            <input className="input" value={adSoy} onChange={e => setAdSoy(e.target.value)} required style={{ flex:1 }} />
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <label style={{ minWidth:110, fontFamily:'Tahoma', fontSize:13, fontWeight:600 }}>TC Kimlik</label>
            <input className="input" value={tcKimlik} onChange={e => setTcKimlik(e.target.value)} maxLength="11" style={{ flex:1 }} />
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <label style={{ minWidth:110, fontFamily:'Tahoma', fontSize:13, fontWeight:600 }}>Cep Telefonu *</label>
            <input className="input" type="tel" value={cepTel} onChange={e => setCepTel(e.target.value)} placeholder="5XX XXX XX XX" required style={{ flex:1 }} />
          </div>
          <div style={{ marginTop:4 }}>
            <button className="btn" type="submit" disabled={yukleniyor || !tarih || !saat}>
              {yukleniyor ? 'Kaydediliyor...' : 'Randevu Ver'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
